import { render, staticRenderFns } from "./configuration.vue?vue&type=template&id=88971262"
import script from "./configuration.vue?vue&type=script&lang=js"
export * from "./configuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports